// Generated by scripts/gen_country_markets.py from the SEO Playbook (§4.5–4.8). Pure data, no imports.

export const COUNTRY_MARKETS = [
 {
  "code": "us",
  "slug": "usa",
  "name": "USA",
  "full": "United States",
  "hreflang": "en-US",
  "geo": "US",
  "currency": null,
  "hero": "Land Survey CAD Drafting Services Provider — USA",
  "intro": "Outsourced survey CAD drafting for US land surveying firms in all 50 states — ALTA/NSPS, boundary, topographic, plats, Civil 3D, GIS and point cloud to CAD.",
  "modifiers": [
   "outsourced",
   "for surveyors",
   "drafting company",
   "CAD production support",
   "white-label drafting",
   "overflow drafting"
  ],
  "seoTitle": "Outsourced Survey CAD Drafting USA | SurveysMaps",
  "seoDescription": "Outsourced survey CAD drafting for US land surveying firms — ALTA/NSPS, boundary, topographic, Civil 3D, GIS and point cloud to CAD across all 50 states and every county we serve.",
  "primaryKeywords": [
   "land survey CAD drafting services provider",
   "outsourced survey CAD drafting",
   "CAD drafting for land surveyors",
   "survey drafting outsourcing",
   "white-label survey drafting",
   "land survey CAD drafting",
   "ALTA survey drafting",
   "Civil 3D survey drafting",
   "GIS mapping services"
  ],
  "serviceKeywords": [
   "boundary survey drafting",
   "topographic survey drafting",
   "plat drafting services",
   "as-built survey drafting",
   "point cloud to CAD",
   "PDF survey to DWG",
   "survey data conversion",
   "existing conditions CAD drawings"
  ],
  "terminology": [
   {
    "term": "ALTA/NSPS Land Title Survey",
    "meaning": "Commercial title survey to the 2021 Minimum Standard Detail Requirements, including Table A items."
   },
   {
    "term": "Plat",
    "meaning": "Recorded subdivision or survey map prepared for county recording."
   },
   {
    "term": "Topo survey",
    "meaning": "Existing-conditions survey with contours, spot elevations and planimetric features."
   }
  ],
  "timezone": "Same-business-day communication across Eastern, Central, Mountain and Pacific time zones.",
  "services": [],
  "cities": [],
  "regions": []
 },
 {
  "code": "ca",
  "slug": "canada",
  "name": "Canada",
  "full": "Canada",
  "hreflang": "en-CA",
  "geo": "CA",
  "currency": {
   "code": "CAD",
   "symbol": "C$",
   "rate": 1.37
  },
  "hero": "Land Survey CAD Drafting Services Provider — Canada",
  "intro": "Outsourced land survey drafting for Canadian surveying and geomatics firms — survey plans, reference plans, topographic drafting, Civil 3D, cadastral and GIS support from Toronto to Vancouver.",
  "modifiers": [
   "outsourced",
   "for surveyors",
   "drafting company",
   "CAD production support",
   "white-label drafting",
   "overflow drafting"
  ],
  "seoTitle": "Land Survey Drafting Services Canada | SurveysMaps",
  "seoDescription": "Outsourced land survey CAD drafting for Canadian surveying firms — survey plan drafting, topographic drafting, Civil 3D, cadastral and GIS mapping support from Toronto to Vancouver.",
  "primaryKeywords": [
   "land survey CAD drafting services provider Canada",
   "outsourced land survey CAD drafting Canada",
   "land survey drafting services Canada",
   "survey CAD drafting company Canada",
   "CAD drafting for land surveyors Canada",
   "outsourced CAD drafting services Canada",
   "survey plan drafting services Canada",
   "topographic survey drafting Canada",
   "Civil 3D survey drafting Canada",
   "GIS mapping services Canada",
   "cadastral survey drafting Canada"
  ],
  "serviceKeywords": [
   "boundary survey plan drafting Canada",
   "subdivision plan CAD drafting Canada",
   "legal survey plan drafting services",
   "construction layout drawing support",
   "as-built survey drafting Canada",
   "point cloud to CAD Canada",
   "survey field data to CAD conversion",
   "contour mapping and CAD drafting",
   "AutoCAD drafting services for surveyors",
   "GIS data conversion services Canada"
  ],
  "terminology": [
   {
    "term": "Survey plan / legal survey plan",
    "meaning": "Plan of survey prepared for registration or deposit — we draft it, your commissioned surveyor certifies it."
   },
   {
    "term": "Reference plan",
    "meaning": "Common Ontario plan type for describing parts of lots — drafted to your template and the applicable provincial rules."
   },
   {
    "term": "Cadastral drafting",
    "meaning": "Parcel fabric, boundary and title-related mapping and plan production."
   }
  ],
  "timezone": "Full working-day overlap with Eastern, Central, Mountain and Pacific Canada.",
  "services": [
   {
    "slug": "outsourced-survey-cad-drafting",
    "concept": "outsourcing",
    "h1": "Outsourced Land Survey CAD Drafting Canada",
    "title": "Outsourced Land Survey CAD Drafting Canada | SurveysMaps",
    "keywords": "outsourced land survey CAD drafting Canada, survey CAD drafting company Canada, outsourced CAD drafting services Canada, white-label drafting, overflow drafting",
    "deliverables": [
     "Overflow & backlog drafting",
     "Your CAD template & layers",
     "Dedicated drafting team",
     "QA-checked drawings",
     "24–48 hr turnaround",
     "NDA-secured file transfer"
    ]
   },
   {
    "slug": "survey-plan-drafting",
    "concept": "boundary",
    "h1": "Survey Plan Drafting Services Canada",
    "title": "Survey Plan Drafting Services Canada | Cadastral Drafting | SurveysMaps",
    "keywords": "survey plan drafting services Canada, legal survey plan drafting services, boundary survey plan drafting Canada, subdivision plan CAD drafting Canada, cadastral survey drafting Canada",
    "deliverables": [
     "Boundary & title plan drawings",
     "Lot / parcel layouts",
     "Bearings, distances & areas",
     "Plan sheets for lodgement checks",
     "Cadastral mapping",
     "Legal description support"
    ]
   },
   {
    "slug": "topographic-survey-drafting",
    "concept": "topo",
    "h1": "Topographic Survey Drafting Canada",
    "title": "Topographic Survey Drafting Canada | Contour Mapping | SurveysMaps",
    "keywords": "topographic survey drafting Canada, contour mapping and CAD drafting, topo survey CAD services, existing conditions CAD drawings",
    "deliverables": [
     "Levels, spot heights & contours",
     "Planimetric features & services",
     "Surfaces / DTM",
     "Annotated survey sheets",
     "DWG, DGN & PDF output",
     "Template-based layering"
    ]
   },
   {
    "slug": "civil-3d-survey-drafting",
    "concept": "civil3d",
    "h1": "Civil 3D Survey Drafting Canada",
    "title": "Civil 3D Survey Drafting Canada | AutoCAD Drafting for Surveyors | SurveysMaps",
    "keywords": "Civil 3D survey drafting Canada, AutoCAD drafting services for surveyors, construction layout drawing support",
    "deliverables": [
     "Civil 3D surfaces",
     "Figure linework from codes",
     "Alignments & profiles",
     "Parcels & labels",
     "Volumes & sections",
     "Template setup"
    ]
   },
   {
    "slug": "gis-mapping-services",
    "concept": "gis",
    "h1": "GIS Mapping Services Canada",
    "title": "GIS Mapping Services Canada | GIS Data Conversion | SurveysMaps",
    "keywords": "GIS mapping services Canada, GIS data conversion services Canada, geospatial mapping services",
    "deliverables": [
     "CAD-to-GIS conversion",
     "Shapefiles & geodatabases",
     "Parcel mapping",
     "Thematic maps",
     "Georeferencing",
     "Data cleanup & QA"
    ]
   },
   {
    "slug": "point-cloud-to-cad",
    "concept": "pointcloud",
    "h1": "Point Cloud to CAD Canada",
    "title": "Point Cloud to CAD Canada | LiDAR to CAD Drafting | SurveysMaps",
    "keywords": "point cloud to CAD Canada, LiDAR to CAD conversion, scan-to-CAD drafting",
    "deliverables": [
     "Point cloud to 2D linework",
     "Surfaces from scans",
     "Building & facade drawings",
     "Classified point clouds",
     "LAS/LAZ/E57/RCP input",
     "3D models"
    ]
   },
   {
    "slug": "survey-data-conversion",
    "concept": "conversion",
    "h1": "Survey Field Data to CAD Conversion Canada",
    "title": "Survey Field Data to CAD Conversion Canada | SurveysMaps",
    "keywords": "survey field data to CAD conversion, point file to CAD conversion, PDF survey to DWG, survey data conversion",
    "deliverables": [
     "PDF to DWG",
     "Point file to CAD",
     "Raster to vector",
     "Field data processing",
     "Coordinate transformations",
     "Legacy drawing updates"
    ]
   },
   {
    "slug": "as-built-survey-drafting",
    "concept": "asbuilt",
    "h1": "As-Built Survey Drafting Canada",
    "title": "As-Built Survey Drafting Canada | SurveysMaps",
    "keywords": "as-built survey drafting Canada, existing conditions CAD drawings, as-built CAD conversion",
    "deliverables": [
     "As-built / as-constructed drawings",
     "Existing conditions CAD",
     "Utility & services records",
     "Redline updates",
     "Close-out packages",
     "DWG & PDF output"
    ]
   }
  ],
  "cities": [
   {
    "name": "Toronto",
    "slug": "toronto",
    "region": "Ontario",
    "context": "GTA survey firms handle heavy volumes of reference plans, topographic surveys for infill and condo development, and site plans for municipal approvals — we provide overflow drafting so field crews stay in the field.",
    "fr": false
   },
   {
    "name": "Vancouver",
    "slug": "vancouver",
    "region": "British Columbia",
    "context": "Lower Mainland surveyors juggle steep-lot topographic work, strata plans and building-permit site surveys — we draft topographic and plan sheets to your template for review and submission.",
    "fr": false
   },
   {
    "name": "Calgary",
    "slug": "calgary",
    "region": "Alberta",
    "context": "Calgary survey and geomatics firms supporting residential subdivision, real property reports and energy-sector projects use us for Civil 3D surfaces and plan production support.",
    "fr": false
   },
   {
    "name": "Edmonton",
    "slug": "edmonton",
    "region": "Alberta",
    "context": "Edmonton firms working on subdivision growth, wellsite and pipeline right-of-way plans rely on outsourced CAD production during peak construction season.",
    "fr": false
   },
   {
    "name": "Ottawa",
    "slug": "ottawa",
    "region": "Ontario",
    "context": "National Capital Region surveyors working on both sides of the Ottawa River use us for topographic drafting, reference plan drafting and GIS data conversion.",
    "fr": false
   },
   {
    "name": "Winnipeg",
    "slug": "winnipeg",
    "region": "Manitoba",
    "context": "Winnipeg survey firms supporting floodplain, drainage and subdivision work use outsourced topographic drafting and contour mapping to keep up with spring and summer volumes.",
    "fr": false
   },
   {
    "name": "Montreal",
    "slug": "montreal",
    "region": "Quebec",
    "context": "Montreal firms working with arpenteurs-géomètres and engineering teams use us for topographic plans, Civil 3D production and point cloud to CAD — with a French-language page available.",
    "fr": true
   }
  ],
  "regions": [
   {
    "name": "Ontario",
    "slug": "ontario",
    "type": "Province"
   },
   {
    "name": "Quebec",
    "slug": "quebec",
    "type": "Province"
   },
   {
    "name": "British Columbia",
    "slug": "british-columbia",
    "type": "Province"
   },
   {
    "name": "Alberta",
    "slug": "alberta",
    "type": "Province"
   },
   {
    "name": "Manitoba",
    "slug": "manitoba",
    "type": "Province"
   },
   {
    "name": "Saskatchewan",
    "slug": "saskatchewan",
    "type": "Province"
   },
   {
    "name": "Nova Scotia",
    "slug": "nova-scotia",
    "type": "Province"
   },
   {
    "name": "New Brunswick",
    "slug": "new-brunswick",
    "type": "Province"
   },
   {
    "name": "Newfoundland and Labrador",
    "slug": "newfoundland-and-labrador",
    "type": "Province"
   },
   {
    "name": "Prince Edward Island",
    "slug": "prince-edward-island",
    "type": "Province"
   },
   {
    "name": "Yukon",
    "slug": "yukon",
    "type": "Territory"
   },
   {
    "name": "Northwest Territories",
    "slug": "northwest-territories",
    "type": "Territory"
   },
   {
    "name": "Nunavut",
    "slug": "nunavut",
    "type": "Territory"
   }
  ]
 },
 {
  "code": "uk",
  "slug": "uk",
  "name": "UK",
  "full": "United Kingdom",
  "hreflang": "en-GB",
  "geo": "GB",
  "currency": {
   "code": "GBP",
   "symbol": "£",
   "rate": 0.79
  },
  "hero": "Land Survey CAD Drafting Services Provider — UK",
  "intro": "Survey drawing services for UK surveying and geomatics practices — topographical survey drawings, measured survey CAD, boundary drawings, point cloud to CAD and GIS mapping.",
  "modifiers": [
   "outsourced",
   "for surveyors",
   "subcontract CAD drafting",
   "outsourced drawing production",
   "CAD production support",
   "overflow drafting"
  ],
  "seoTitle": "Survey Drawing Services UK | Topographical Survey Drafting | SurveysMaps",
  "seoDescription": "Outsourced survey CAD drafting and survey drawing services for UK surveying and geomatics firms — topographical survey drawings, measured survey CAD, point cloud to CAD and GIS mapping.",
  "primaryKeywords": [
   "land survey CAD drafting services provider UK",
   "outsourced survey CAD drafting UK",
   "land survey CAD drafting services UK",
   "survey drawing services UK",
   "CAD drafting for land surveyors UK",
   "outsourced CAD services for surveyors UK",
   "topographical survey CAD drawing",
   "topographical survey drafting services",
   "survey plan drawing services UK",
   "AutoCAD survey drafting UK",
   "GIS mapping services UK"
  ],
  "serviceKeywords": [
   "measured survey CAD drawing services",
   "topographical survey drawing production",
   "boundary survey drawing services UK",
   "existing site survey CAD drawings",
   "Civil 3D survey drafting UK",
   "point cloud to CAD conversion UK",
   "LiDAR data to CAD drawings",
   "survey data processing and CAD drafting",
   "land survey drawing outsourcing",
   "geospatial data conversion services UK",
   "contour drawing and terrain modelling",
   "as-built survey CAD drawings UK"
  ],
  "terminology": [
   {
    "term": "Topographical survey",
    "meaning": "Land and site features — levels, contours, boundaries, hardstanding, trees, drainage and services."
   },
   {
    "term": "Measured building survey",
    "meaning": "Building interiors, floor plans, elevations and sections — delivered through our architectural as-built drafting service."
   },
   {
    "term": "Survey drawing",
    "meaning": "The finished CAD drawing produced from survey data, ready for your checking and issue."
   }
  ],
  "timezone": "Time-zone advantage: send data at close of business, receive drawings for the next morning.",
  "services": [
   {
    "slug": "outsourced-survey-cad-drafting",
    "concept": "outsourcing",
    "h1": "Outsourced Survey CAD Drafting UK",
    "title": "Outsourced Survey CAD Drafting UK | Subcontract CAD Drafting | SurveysMaps",
    "keywords": "outsourced survey CAD drafting UK, outsourced CAD services for surveyors UK, land survey drawing outsourcing, subcontract CAD drafting, outsourced drawing production",
    "deliverables": [
     "Overflow & backlog drafting",
     "Your CAD template & layers",
     "Dedicated drafting team",
     "QA-checked drawings",
     "24–48 hr turnaround",
     "NDA-secured file transfer"
    ]
   },
   {
    "slug": "topographical-survey-drafting",
    "concept": "topo",
    "h1": "Topographical Survey CAD Drawing Services UK",
    "title": "Topographical Survey CAD Drawing Services UK | SurveysMaps",
    "keywords": "topographical survey CAD drawing, topographical survey drafting services, topographical survey drawing production, existing site survey CAD drawings, contour drawing and terrain modelling",
    "deliverables": [
     "Levels, spot heights & contours",
     "Planimetric features & services",
     "Surfaces / DTM",
     "Annotated survey sheets",
     "DWG, DGN & PDF output",
     "Template-based layering"
    ]
   },
   {
    "slug": "boundary-survey-drawings",
    "concept": "boundary",
    "h1": "Boundary Survey Drawing Services UK",
    "title": "Boundary Survey Drawing Services UK | SurveysMaps",
    "keywords": "boundary survey drawing services UK, property survey CAD drafting, title plan overlay drawings",
    "deliverables": [
     "Boundary & title plan drawings",
     "Lot / parcel layouts",
     "Bearings, distances & areas",
     "Plan sheets for lodgement checks",
     "Cadastral mapping",
     "Legal description support"
    ]
   },
   {
    "slug": "civil-3d-survey-drafting",
    "concept": "civil3d",
    "h1": "Civil 3D Survey Drafting UK",
    "title": "Civil 3D Survey Drafting UK | AutoCAD Survey Drafting | SurveysMaps",
    "keywords": "Civil 3D survey drafting UK, AutoCAD survey drafting UK, contour drawing and terrain modelling",
    "deliverables": [
     "Civil 3D surfaces",
     "Figure linework from codes",
     "Alignments & profiles",
     "Parcels & labels",
     "Volumes & sections",
     "Template setup"
    ]
   },
   {
    "slug": "gis-mapping-services",
    "concept": "gis",
    "h1": "GIS Mapping Services UK",
    "title": "GIS Mapping Services UK | Geospatial Data Conversion | SurveysMaps",
    "keywords": "GIS mapping services UK, geospatial data conversion services UK, GIS data conversion",
    "deliverables": [
     "CAD-to-GIS conversion",
     "Shapefiles & geodatabases",
     "Parcel mapping",
     "Thematic maps",
     "Georeferencing",
     "Data cleanup & QA"
    ]
   },
   {
    "slug": "point-cloud-to-cad",
    "concept": "pointcloud",
    "h1": "Point Cloud to CAD Conversion UK",
    "title": "Point Cloud to CAD Conversion UK | LiDAR Data to CAD Drawings | SurveysMaps",
    "keywords": "point cloud to CAD conversion UK, LiDAR data to CAD drawings, scan-to-CAD drafting",
    "deliverables": [
     "Point cloud to 2D linework",
     "Surfaces from scans",
     "Building & facade drawings",
     "Classified point clouds",
     "LAS/LAZ/E57/RCP input",
     "3D models"
    ]
   },
   {
    "slug": "survey-data-processing",
    "concept": "conversion",
    "h1": "Survey Data Processing and CAD Drafting UK",
    "title": "Survey Data Processing and CAD Drafting UK | SurveysMaps",
    "keywords": "survey data processing and CAD drafting, point file to CAD conversion, PDF survey to DWG",
    "deliverables": [
     "PDF to DWG",
     "Point file to CAD",
     "Raster to vector",
     "Field data processing",
     "Coordinate transformations",
     "Legacy drawing updates"
    ]
   },
   {
    "slug": "as-built-survey-drawings",
    "concept": "asbuilt",
    "h1": "As-Built Survey CAD Drawings UK",
    "title": "As-Built Survey CAD Drawings UK | SurveysMaps",
    "keywords": "as-built survey CAD drawings UK, existing site survey CAD drawings, as-built CAD conversion",
    "deliverables": [
     "As-built / as-constructed drawings",
     "Existing conditions CAD",
     "Utility & services records",
     "Redline updates",
     "Close-out packages",
     "DWG & PDF output"
    ]
   }
  ],
  "cities": [
   {
    "name": "London",
    "slug": "london",
    "region": "England",
    "context": "London practices handle dense urban topographical surveys, basement and infill sites, and point cloud work for planning submissions — we provide overnight drawing production to keep programmes on track.",
    "fr": false
   },
   {
    "name": "Birmingham",
    "slug": "birmingham",
    "region": "England",
    "context": "West Midlands geomatics firms supporting regeneration and infrastructure schemes use us for topographical survey drafting and Civil 3D terrain models.",
    "fr": false
   },
   {
    "name": "Manchester",
    "slug": "manchester",
    "region": "England",
    "context": "Greater Manchester surveyors working on residential growth and city-centre development rely on subcontract CAD drafting for topographical and existing site survey drawings.",
    "fr": false
   },
   {
    "name": "Bristol",
    "slug": "bristol",
    "region": "England",
    "context": "Bristol and South West survey practices use us for topographical drawings, boundary survey drawings and LiDAR data to CAD.",
    "fr": false
   },
   {
    "name": "Leeds",
    "slug": "leeds",
    "region": "England",
    "context": "Leeds and West Yorkshire firms send survey data for topographical drafting, drainage detail and as-built CAD drawings.",
    "fr": false
   },
   {
    "name": "Glasgow",
    "slug": "glasgow",
    "region": "Scotland",
    "context": "Glasgow surveyors supporting regeneration, utilities and infrastructure work use outsourced drawing production and point cloud to CAD conversion.",
    "fr": false
   },
   {
    "name": "Edinburgh",
    "slug": "edinburgh",
    "region": "Scotland",
    "context": "Edinburgh practices working on heritage-sensitive and urban sites use our point cloud to CAD and topographical drafting services.",
    "fr": false
   },
   {
    "name": "Cardiff",
    "slug": "cardiff",
    "region": "Wales",
    "context": "Cardiff and South Wales firms use subcontract survey drafting for topographical, boundary and GIS mapping work.",
    "fr": false
   }
  ],
  "regions": [
   {
    "name": "England",
    "slug": "england",
    "type": "Nation"
   },
   {
    "name": "Scotland",
    "slug": "scotland",
    "type": "Nation"
   },
   {
    "name": "Wales",
    "slug": "wales",
    "type": "Nation"
   },
   {
    "name": "Northern Ireland",
    "slug": "northern-ireland",
    "type": "Nation"
   },
   {
    "name": "Greater London",
    "slug": "greater-london",
    "type": "County"
   },
   {
    "name": "West Midlands",
    "slug": "west-midlands",
    "type": "County"
   },
   {
    "name": "Greater Manchester",
    "slug": "greater-manchester",
    "type": "County"
   },
   {
    "name": "West Yorkshire",
    "slug": "west-yorkshire",
    "type": "County"
   },
   {
    "name": "Merseyside",
    "slug": "merseyside",
    "type": "County"
   },
   {
    "name": "Kent",
    "slug": "kent",
    "type": "County"
   },
   {
    "name": "Essex",
    "slug": "essex",
    "type": "County"
   },
   {
    "name": "Surrey",
    "slug": "surrey",
    "type": "County"
   },
   {
    "name": "Hampshire",
    "slug": "hampshire",
    "type": "County"
   },
   {
    "name": "Lancashire",
    "slug": "lancashire",
    "type": "County"
   },
   {
    "name": "Hertfordshire",
    "slug": "hertfordshire",
    "type": "County"
   },
   {
    "name": "Oxfordshire",
    "slug": "oxfordshire",
    "type": "County"
   }
  ]
 },
 {
  "code": "au",
  "slug": "australia",
  "name": "Australia",
  "full": "Australia",
  "hreflang": "en-AU",
  "geo": "AU",
  "currency": {
   "code": "AUD",
   "symbol": "A$",
   "rate": 1.53
  },
  "hero": "Land Survey CAD Drafting Services Provider — Australia",
  "intro": "Subcontract survey drafting for Australian survey practices — feature and level surveys, detail and contour plans, cadastral and subdivision plans, as-constructed drawings and LiDAR to CAD.",
  "modifiers": [
   "outsourced",
   "for surveyors",
   "subcontract drafting",
   "CAD production support",
   "white-label drafting",
   "overflow drafting"
  ],
  "seoTitle": "Feature and Level Survey Drafting Australia | SurveysMaps",
  "seoDescription": "Outsourced survey CAD drafting for Australian surveying firms — feature and level survey drafting, detail and contour surveys, cadastral drafting, Civil 3D and LiDAR to CAD.",
  "primaryKeywords": [
   "land survey CAD drafting services provider Australia",
   "outsourced survey CAD drafting Australia",
   "land survey drafting services Australia",
   "survey drafting services Australia",
   "CAD drafting for surveyors Australia",
   "topographic survey drafting Australia",
   "feature and level survey drafting",
   "detail survey CAD drafting",
   "Civil 3D survey drafting Australia",
   "GIS mapping services Australia",
   "cadastral survey drafting Australia"
  ],
  "serviceKeywords": [
   "feature survey CAD drawing services",
   "feature and level survey CAD drawings",
   "detail and contour survey drafting",
   "boundary survey plan drafting Australia",
   "subdivision plan drafting services Australia",
   "existing conditions survey CAD drawings",
   "survey field data to CAD conversion Australia",
   "point cloud to CAD Australia",
   "LiDAR to CAD drafting services Australia",
   "as-constructed survey drafting",
   "survey data processing services Australia",
   "geospatial data conversion Australia"
  ],
  "terminology": [
   {
    "term": "Feature and level survey",
    "meaning": "Site features plus spot levels and contours — commonly required for development applications and design."
   },
   {
    "term": "Detail survey",
    "meaning": "Detailed existing-conditions survey of a site; often used interchangeably with feature survey."
   },
   {
    "term": "As-constructed survey",
    "meaning": "Post-construction survey of works as built — the Australian equivalent of an as-built survey in many contexts."
   }
  ],
  "timezone": "Overnight production: lodge data at close of business in AEST/AWST and receive drafts back for checking.",
  "services": [
   {
    "slug": "outsourced-survey-cad-drafting",
    "concept": "outsourcing",
    "h1": "Outsourced Survey CAD Drafting Australia",
    "title": "Outsourced Survey CAD Drafting Australia | Subcontract Drafting | SurveysMaps",
    "keywords": "outsourced survey CAD drafting Australia, survey drafting services Australia, CAD drafting for surveyors Australia, subcontract drafting, overflow drafting",
    "deliverables": [
     "Overflow & backlog drafting",
     "Your CAD template & layers",
     "Dedicated drafting team",
     "QA-checked drawings",
     "24–48 hr turnaround",
     "NDA-secured file transfer"
    ]
   },
   {
    "slug": "feature-and-level-survey-drafting",
    "concept": "topo",
    "h1": "Feature and Level Survey Drafting Australia",
    "title": "Feature and Level Survey Drafting Australia | Feature Survey CAD | SurveysMaps",
    "keywords": "feature and level survey drafting, feature and level survey CAD drawings, feature survey CAD drawing services, topographic survey drafting Australia",
    "deliverables": [
     "Levels, spot heights & contours",
     "Planimetric features & services",
     "Surfaces / DTM",
     "Annotated survey sheets",
     "DWG, DGN & PDF output",
     "Template-based layering"
    ]
   },
   {
    "slug": "detail-and-contour-survey-drafting",
    "concept": "detail",
    "h1": "Detail Survey CAD Drafting Australia",
    "title": "Detail Survey CAD Drafting Australia | Detail and Contour Surveys | SurveysMaps",
    "keywords": "detail survey CAD drafting, detail and contour survey drafting, existing conditions survey CAD drawings",
    "deliverables": [
     "Detail & contour plans",
     "Existing features & levels",
     "Surface models",
     "Annotated plan sheets",
     "DWG & PDF output",
     "Your title block"
    ]
   },
   {
    "slug": "cadastral-survey-drafting",
    "concept": "boundary",
    "h1": "Cadastral Survey Drafting Australia",
    "title": "Cadastral Survey Drafting Australia | Subdivision Plan Drafting | SurveysMaps",
    "keywords": "cadastral survey drafting Australia, boundary survey plan drafting Australia, subdivision plan drafting services Australia",
    "deliverables": [
     "Boundary & title plan drawings",
     "Lot / parcel layouts",
     "Bearings, distances & areas",
     "Plan sheets for lodgement checks",
     "Cadastral mapping",
     "Legal description support"
    ]
   },
   {
    "slug": "civil-3d-survey-drafting",
    "concept": "civil3d",
    "h1": "Civil 3D Survey Drafting Australia",
    "title": "Civil 3D Survey Drafting Australia | SurveysMaps",
    "keywords": "Civil 3D survey drafting Australia, AutoCAD Civil 3D drafting services",
    "deliverables": [
     "Civil 3D surfaces",
     "Figure linework from codes",
     "Alignments & profiles",
     "Parcels & labels",
     "Volumes & sections",
     "Template setup"
    ]
   },
   {
    "slug": "gis-mapping-services",
    "concept": "gis",
    "h1": "GIS Mapping Services Australia",
    "title": "GIS Mapping Services Australia | Geospatial Data Conversion | SurveysMaps",
    "keywords": "GIS mapping services Australia, geospatial data conversion Australia, GIS data conversion",
    "deliverables": [
     "CAD-to-GIS conversion",
     "Shapefiles & geodatabases",
     "Parcel mapping",
     "Thematic maps",
     "Georeferencing",
     "Data cleanup & QA"
    ]
   },
   {
    "slug": "point-cloud-to-cad",
    "concept": "pointcloud",
    "h1": "Point Cloud to CAD Australia",
    "title": "Point Cloud to CAD Australia | LiDAR to CAD Drafting Services | SurveysMaps",
    "keywords": "point cloud to CAD Australia, LiDAR to CAD drafting services Australia, scan-to-CAD drafting",
    "deliverables": [
     "Point cloud to 2D linework",
     "Surfaces from scans",
     "Building & facade drawings",
     "Classified point clouds",
     "LAS/LAZ/E57/RCP input",
     "3D models"
    ]
   },
   {
    "slug": "survey-data-processing",
    "concept": "conversion",
    "h1": "Survey Data Processing Services Australia",
    "title": "Survey Data Processing Services Australia | Field Data to CAD | SurveysMaps",
    "keywords": "survey data processing services Australia, survey field data to CAD conversion Australia, PDF survey to DWG",
    "deliverables": [
     "PDF to DWG",
     "Point file to CAD",
     "Raster to vector",
     "Field data processing",
     "Coordinate transformations",
     "Legacy drawing updates"
    ]
   },
   {
    "slug": "as-constructed-survey-drafting",
    "concept": "asbuilt",
    "h1": "As-Constructed Survey Drafting Australia",
    "title": "As-Constructed Survey Drafting Australia | SurveysMaps",
    "keywords": "as-constructed survey drafting, existing conditions survey CAD drawings, as-built CAD conversion",
    "deliverables": [
     "As-built / as-constructed drawings",
     "Existing conditions CAD",
     "Utility & services records",
     "Redline updates",
     "Close-out packages",
     "DWG & PDF output"
    ]
   }
  ],
  "cities": [
   {
    "name": "Sydney",
    "slug": "sydney",
    "region": "New South Wales",
    "context": "Sydney survey practices produce high volumes of feature and level surveys for development applications — we provide overnight drafting so plans are ready for checking each morning.",
    "fr": false
   },
   {
    "name": "Melbourne",
    "slug": "melbourne",
    "region": "Victoria",
    "context": "Melbourne firms working on feature surveys, re-establishment and plans of subdivision use us for subcontract drafting during peak periods.",
    "fr": false
   },
   {
    "name": "Brisbane",
    "slug": "brisbane",
    "region": "Queensland",
    "context": "Brisbane surveyors supporting residential growth and infrastructure use our detail and contour survey drafting and Civil 3D services.",
    "fr": false
   },
   {
    "name": "Perth",
    "slug": "perth",
    "region": "Western Australia",
    "context": "Perth firms handling feature surveys, subdivisions and resource-sector work use outsourced CAD production and LiDAR to CAD.",
    "fr": false
   },
   {
    "name": "Adelaide",
    "slug": "adelaide",
    "region": "South Australia",
    "context": "Adelaide survey practices use us for feature and level drafting, contour plans and as-constructed drawings.",
    "fr": false
   },
   {
    "name": "Canberra",
    "slug": "canberra",
    "region": "Australian Capital Territory",
    "context": "Canberra firms supporting government and infill development projects use our detail survey and GIS mapping services.",
    "fr": false
   },
   {
    "name": "Gold Coast",
    "slug": "gold-coast",
    "region": "Queensland",
    "context": "Gold Coast surveyors working on coastal, high-rise and residential sites use our feature survey CAD drawing and point cloud services.",
    "fr": false
   }
  ],
  "regions": [
   {
    "name": "New South Wales",
    "slug": "new-south-wales",
    "type": "State"
   },
   {
    "name": "Victoria",
    "slug": "victoria",
    "type": "State"
   },
   {
    "name": "Queensland",
    "slug": "queensland",
    "type": "State"
   },
   {
    "name": "Western Australia",
    "slug": "western-australia",
    "type": "State"
   },
   {
    "name": "South Australia",
    "slug": "south-australia",
    "type": "State"
   },
   {
    "name": "Tasmania",
    "slug": "tasmania",
    "type": "State"
   },
   {
    "name": "Australian Capital Territory",
    "slug": "australian-capital-territory",
    "type": "Territory"
   },
   {
    "name": "Northern Territory",
    "slug": "northern-territory",
    "type": "Territory"
   }
  ]
 }
];

export const US_CONCEPT_PAGES = {
 "outsourcing": "/survey-cad-outsourcing",
 "gis": "/gis-mapping-services",
 "pointcloud": "/lidar-point-cloud-to-cad",
 "conversion": "/survey-data-conversion",
 "civil3d": "/civil-3d-survey-drafting",
 "topo": "/services/land-surveying/topographic-survey-drafting",
 "boundary": "/services/land-surveying/boundary-survey-drafting",
 "asbuilt": "/services/land-surveying/as-built-survey-drafting"
};

export const MARKETS_BY_SLUG = Object.fromEntries(COUNTRY_MARKETS.map(m => [m.slug, m]));

export const HUB_ALTERNATES = [
  ...COUNTRY_MARKETS.map(m => ({ hreflang: m.hreflang, path: `/${m.slug}` })),
  { hreflang: 'x-default', path: '/' },
];

export const conceptAlternates = (concept) => {
  const us = US_CONCEPT_PAGES[concept];
  if (!us) return [];
  const alts = [{ hreflang: 'en-US', path: us }];
  COUNTRY_MARKETS.forEach(m => {
    const s = m.services.find(x => x.concept === concept);
    if (s) alts.push({ hreflang: m.hreflang, path: `/${m.slug}/${s.slug}` });
  });
  return alts.length > 1 ? [...alts, { hreflang: 'x-default', path: us }] : [];
};

export const conceptLink = (market, concept) => {
  const s = market.services.find(x => x.concept === concept) || market.services.find(x => x.concept === 'outsourcing');
  return market.code === 'us' || !s ? (US_CONCEPT_PAGES[concept] || '/survey-cad-outsourcing') : `/${market.slug}/${s.slug}`;
};
